export default __webpack_public_path__ + "static/media/footer.ba3fba6e.svg";